module.exports = __webpack_public_path__ + "img/bee__3.b7790086.svg";